const STORAGE_KEY = "sonic-collection-view";

class CollectionView extends HTMLElement {
  connectedCallback() {
    this.buttons = this.querySelectorAll("[data-view]");
    this.grid = document.querySelector("[data-product-grid]");

    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && [...this.buttons].some((b) => b.dataset.view === stored)) {
      this._setView(stored);
    }

    this.buttons.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        this._setView(btn.dataset.view);
        localStorage.setItem(STORAGE_KEY, btn.dataset.view);
      });
    });
  }

  _setView(view) {
    this.buttons.forEach((b) =>
      b.classList.toggle("active", b.dataset.view === view),
    );
    if (this.grid) this.grid.dataset.view = view;
  }
}

if (!customElements.get("collection-view")) {
  customElements.define("collection-view", CollectionView);
}
